import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController,ModalController } from 'ionic-angular';

import { Assessment } from '../../models/assessment';
import { Items } from '../../providers/providers';
import { Batteries } from '../../models/batteries';
import { Client } from '../../models/client';
import { AddBatteryPage } from '../add-battery/add-battery';

/**
 * Generated class for the AssessmentTabPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage({
  name: 'assessments',
  segment: 'assessments',
  priority: 'high'
})
@Component({
  selector: 'page-assessment-tab',
  templateUrl: 'assessment-tab.html',
})
export class AssessmentTabPage {

  clientId: string = this.navParams.get('clientId');
  assessments: Assessment[];
  batteries: Batteries[]
  battery: Batteries;
  assessment: Assessment;
  text: string;
  isCommonAssessmentSelected: boolean;
  isAssessmentSelected: boolean
  selected: string;
  page_search: string = '';
  menu_search: string = '';
  show_result: boolean = false;
  displayList: Client[];

  selectedAssessments: { short_name: string, extended_name: string} = {
    short_name: 'First Name',
    extended_name: 'Last Name'
  };

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public modalCtrl: ModalController,public items: Items) {
    this.text = 'uncommonAssessment';
    this.isCommonAssessmentSelected = false;
    this.selected = "assessment"
  }

  ionViewDidLoad() {
    //moved the call to api from constructor to here. 19/03/2018
    this.items.getAssessmentList().subscribe(res => {
      if (res) {
        this.assessments = res;
        localStorage.setItem('assessments', JSON.stringify(this.assessments));
        this.assessmentSelected(this.assessments[0])
      }
    }, err => {
      console.error('ERROR', err);
    });

    this.items.getBatteries().subscribe(res => {
      if (res) {
        var batteriesList =[];
        batteriesList = res;
        // this.batteries = res;
        this.batteries = batteriesList.sort(function(a,b){
          return a.name > b.name ? 1:a.name < b.name ? -1:0
         })
        // localStorage.setItem('assessments', JSON.stringify(this.assessments));
      }
    }, err => {
      console.error('ERROR', err);
    });
    
  }


  setTab(val){
    if(val == "assessment"){
      this.selected = val;
      this.text = "commonAssessment";
    }else{
      this.selected = val;
      this.text = "battery";
    }
    
  }

  cancel() {
    this.viewCtrl.dismiss();
  }

  assessmentSelected(item){
    this.assessment = item;
    this.text = 'uncommonAssessment';
    this.isCommonAssessmentSelected = false;
  }

  batterySelected(item){
    this.battery = item;
    this.text = 'batterySelected';
  }

  commonAssessmentSelected(item){
    this.text = 'commonAssessment';
    this.assessment = null;
    this.isCommonAssessmentSelected = true;
    
  }
  commonAssessmentChange(assessment){
    this.assessment = assessment;
    this.text = 'uncommonAssessment';
  }

  batteryChange(battery){
    if(battery.active == "0"){
      this.deleteBattery(battery);
    }else{
      this.items.getBatteries().subscribe(res => {
        if (res) {
          this.batteries = res;
          this.battery = battery;
        }
      }, err => {
        console.error('ERROR', err);
      });
    }
  }

  filterAssessments(ev) {
    var val = ev.target.value;
    this.assessments = this.items.getAssessments(val);
    return this.assessments;
    
  }

  addBattery(){
    let modal = this.modalCtrl.create(AddBatteryPage,null,{cssClass:"add-battery-modal"});
    modal.onDidDismiss(item => {
      if (item) {
        let seq =  this.items.addBattery({name:item.form.name, description: item.form.description, assessments: item.assessments}).share();
        seq
          .map(res => res.json().data.battery)
          .subscribe(res => {
            if(res){
              this.batteries = this.items.getBatteryList();
              var index = this.batteries.findIndex(item => item.id === res.id);
              this.batterySelected(this.batteries[index]);
              
            }
          }, err => {
            console.error('ERROR', err);
          });
      }
    })
    modal.present();
  }

  deleteBattery(battery){
    this.batteries = this.items.getBatteryList();
    this.battery = this.batteries[0];
  }

  goToClientsPage(){
    this.navCtrl.push('clients');
  }
  
  goToHomePage(){
    this.navCtrl.push('home');
  }
  
  goToAssessmentsPage(){
    this.navCtrl.push('assessments');
  }

  goToInsightPage() {
    this.navCtrl.push('redirect-insights');
  }
  
  goToAccountsPage(){
    this.navCtrl.push('account');
  }

  selectClient(item) {
    this.navCtrl.push('clients', { clientId: item.id, client: item })

  }

  onInput() {
    var menu_search = this.menu_search.trim()
  
    if (menu_search.length < 3) {
      this.displayList = [];
      this.show_result = false;
    } else {      
      this.items.getClientSmallList(this.menu_search).subscribe(res => {
        if (res) {
          this.displayList = res;
          this.show_result = true;
          return this.displayList;
          }
      }, err => {
        console.error('ERROR', err);
      });
    }    
  }

}



// WEBPACK FOOTER //
// ./src/pages/assessment-tab/assessment-tab.ts